__turbopack_context__.v({
  "creameryDiningHours": "CreameryDiningHours-module-scss-module__BTjPcW__creameryDiningHours",
  "creameryDiningHoursFlex": "CreameryDiningHours-module-scss-module__BTjPcW__creameryDiningHoursFlex",
  "headline": "CreameryDiningHours-module-scss-module__BTjPcW__headline",
  "icon": "CreameryDiningHours-module-scss-module__BTjPcW__icon",
  "iconWrapper": "CreameryDiningHours-module-scss-module__BTjPcW__iconWrapper",
  "list": "CreameryDiningHours-module-scss-module__BTjPcW__list",
  "listItem": "CreameryDiningHours-module-scss-module__BTjPcW__listItem",
  "listItemLabel": "CreameryDiningHours-module-scss-module__BTjPcW__listItemLabel",
  "listItemLabelIcon": "CreameryDiningHours-module-scss-module__BTjPcW__listItemLabelIcon",
  "listItemLabelIconInner": "CreameryDiningHours-module-scss-module__BTjPcW__listItemLabelIconInner",
  "listItemLabelText": "CreameryDiningHours-module-scss-module__BTjPcW__listItemLabelText",
  "richEyebrow": "CreameryDiningHours-module-scss-module__BTjPcW__richEyebrow",
});
